import { HotWheelsDashboard } from './hotwheels-dashboard';

export function HotWheelsDashboardPage() {
  return <HotWheelsDashboard />;
}

export default HotWheelsDashboardPage;